import React from 'react';

export const CATALOG_COLOR_PALETTE = [
  '#1d4ed8',
  '#2563eb',
  '#0284c7',
  '#0ea5e9',
  '#0d9488',
  '#16a34a',
  '#166534',
  '#c2410c',
  '#ea580c',
  '#d97706',
  '#a16207',
  '#f59e0b',
  '#7c3aed',
  '#8b5cf6',
  '#a855f7',
  '#b91c1c',
  '#dc2626',
  '#be185d',
  '#334155',
  '#4b5563',
  '#6b7280',
  '#78716c',
];

const normalizeHex = (value) => {
  const raw = String(value || '').trim();
  if (/^#[0-9a-fA-F]{6}$/.test(raw)) return raw.toLowerCase();
  if (/^[0-9a-fA-F]{6}$/.test(raw)) return `#${raw.toLowerCase()}`;
  return '';
};

/**
 * Paleta de colores para catálogos de Ajustes (sin escribir HEX).
 */
export const ColorPaletteField = ({
  value = '',
  onChange,
  colors,
  label = 'Color',
  muted = '#64748b',
  text = '#0f172a',
  border = '#d8dee8',
}) => {
  const selected = normalizeHex(value) || '#2563eb';
  const swatches = colors && colors.length ? colors : CATALOG_COLOR_PALETTE;
  const isCustom = selected && !swatches.some((hex) => hex.toLowerCase() === selected);

  return (
    <div>
      <div style={{ fontSize: 12, color: text, marginBottom: 8 }}>{label}</div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(28px, 1fr))',
          gap: 8,
          maxWidth: 360,
        }}
      >
        {swatches.map((hex) => {
          const active = hex.toLowerCase() === selected;
          return (
            <button
              key={hex}
              type="button"
              title={hex}
              aria-label={`Color ${hex}`}
              aria-pressed={active}
              onClick={() => onChange?.(hex)}
              style={{
                width: 28,
                height: 28,
                borderRadius: 8,
                background: hex,
                border: active ? `2px solid ${text}` : `1px solid ${border}`,
                boxShadow: active ? `0 0 0 2px ${hex}` : 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            />
          );
        })}
        <label
          title="Color personalizado"
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            border: isCustom ? `2px solid ${text}` : `1px dashed ${border}`,
            overflow: 'hidden',
            cursor: 'pointer',
            position: 'relative',
            background: isCustom
              ? selected
              : 'conic-gradient(#ef4444, #eab308, #22c55e, #3b82f6, #a855f7, #ef4444)',
          }}
        >
          <input
            type="color"
            value={selected}
            onChange={(event) => onChange?.(event.target.value)}
            aria-label="Elegir color personalizado"
            style={{
              position: 'absolute',
              inset: -4,
              width: 36,
              height: 36,
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              opacity: 0,
            }}
          />
        </label>
      </div>
      <div style={{ fontSize: 11, color: muted, marginTop: 6 }}>Elige un color de la paleta.</div>
    </div>
  );
};

export default ColorPaletteField;
